import React, { useContext } from 'react';
import { Button } from 'antd';
import intl from 'react-intl-universal';
import { PayContext } from './ContextProvider';
import './PaymentDlg.scss';
import FailIcon from '@/assets/PaymentDlg/fail.svg';

const PayResFail = () => {
  const { isFree, setIsPaying } = useContext(PayContext);
  const titleKey = isFree ? 'account.FailSevenTrail' : 'account.PayFail';
  const title = intl.formatMessage({ id: titleKey });

  const FailTip = intl.formatMessage({ id: 'account.FailTip' });
  const FailTip1 = intl.formatMessage({ id: 'account.FailTip1' });
  const FailWhy = intl.formatMessage({ id: 'account.FailWhy' });
  const FailWhy1 = intl.formatMessage({ id: 'account.FailWhy1' });
  const FailWhy2 = intl.formatMessage({ id: 'account.FailWhy2' });
  const btn = intl.formatMessage({ id: 'account.BackRetry' });

  return (
    <div className='pay-res-box'>
      <img src={FailIcon} />
      <h6>{title}</h6>
      <p>{FailTip}<br/>{FailTip1}</p>

      <div className='fail-why'>
        <p className='suc-tip-title'>{FailWhy}</p>
        <ul className='fail-ul'>
          <li>{FailWhy1}</li>
          <li>{FailWhy2}</li>
        </ul>
      </div>
      <Button onClick={() => setIsPaying(false)}>{btn}</Button>
    </div>
  );
};
export default PayResFail;